import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isOfflinePlay } from '../offline-play';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isOfflinePlay(route.queryParamMap)) return true;
  if (await authService.isLoggedIn()) return true;

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
